/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from 'ionic-angular/components/spinner/spinner';
import * as import3 from 'ionic-angular/config/config';
const styles_Spinner:any[] = ([] as any[]);
export const RenderType_Spinner:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_Spinner,
  data: {}
}
);
function View_Spinner_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,':svg:svg',[[
        'viewBox',
        '0 0 64 64'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgStyle,[
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngStyle: [
        0,
        'ngStyle'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[[
        'transform',
        'translate(32,32)'
      ]
      ],[[
        1,
        'r',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.style;
    ck(v,1,0,currVal_0);
  },(ck,v) => {
    const currVal_1:any = v.context.$implicit.r;
    ck(v,2,0,currVal_1);
  });
}
function View_Spinner_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,':svg:svg',[[
        'viewBox',
        '0 0 64 64'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgStyle,[
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngStyle: [
        0,
        'ngStyle'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:line',[[
        'transform',
        'translate(32,32)'
      ]
    ],[
      [
        1,
        'y1',
        0
      ]
      ,
      [
        1,
        'y2',
        0
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.style;
    ck(v,1,0,currVal_0);
  },(ck,v) => {
    const currVal_1:any = v.context.$implicit.y1;
    const currVal_2:any = v.context.$implicit.y2;
    ck(v,2,0,currVal_1,currVal_2);
  });
}
export function View_Spinner_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_Spinner_1)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_Spinner_2)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import2.Spinner = v.component;
    const currVal_0:any = co._c;
    ck(v,1,0,currVal_0);
    const currVal_1:any = co._l;
    ck(v,3,0,currVal_1);
  },(null as any));
}
function View_Spinner_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-spinner',([] as any[]),[[
        2,
        'spinner-paused',
        (null as any)
      ]
    ],(null as any),(null as any),View_Spinner_0,RenderType_Spinner)),
    import0.ɵdid(114688,(null as any),0,import2.Spinner,[
      import3.Config,
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1)._paused;
    ck(v,0,0,currVal_0);
  });
}
export const SpinnerNgFactory:import0.ComponentFactory<import2.Spinner> = import0.ɵccf('ion-spinner',import2.Spinner,View_Spinner_Host_0,{
  color: 'color',
  mode: 'mode',
  name: 'name',
  duration: 'duration',
  paused: 'paused'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/spinner/spinner.ngfactory.ts